// ponytail: local drop-in for @mui/styles/withTheme.
import React from "react";
import { useTheme } from "@mui/material/styles";

export default function withTheme(Component) {
  function WithTheme(props) {
    const theme = useTheme();
    return <Component {...props} theme={theme} />;
  }
  WithTheme.displayName = `withTheme(${
    Component.displayName || Component.name || "Component"
  })`;
  return WithTheme;
}

export { withTheme };
